// Module access policy (Admin → Roles → Module access) — server: routes/modulePolicy.ts.
import { apiRequest } from '../api';

export type ModuleLevel = 'admin' | 'owner';
export type ModuleLevelChoice = ModuleLevel | 'everyone';
export type ModulePolicyOverview = {
  modules: { key: string; icon: string; shared: boolean }[];
  policy: Record<string, ModuleLevel>;          // effective: the stored policy, else the product default
  defaultPolicy: Record<string, ModuleLevel>;
  custom: boolean;                              // true = this workspace saved its own policy
  ownerCount: number;                           // members of the Owner role
  mayChangeOwner: boolean;                      // false = owner-level entries are locked for this admin
};

export const getModulePolicy = (): Promise<ModulePolicyOverview> => apiRequest('GET', '/module-policy');
export const saveModulePolicy = (policy: Record<string, ModuleLevelChoice>): Promise<ModulePolicyOverview & { ok: boolean }> =>
  apiRequest('PUT', '/module-policy', { policy });
export const resetModulePolicy = (): Promise<ModulePolicyOverview & { ok: boolean }> =>
  apiRequest('PUT', '/module-policy', { reset: true });
